import gettext from '@sdk/lang/gettext';
import { format, isSameYear } from 'date-fns';
import formatTime from '@sdk/utils/dateFormat/formatTime';

import { TaskInstance } from '@web/shiftTasks/types/TaskInstance';

export function getShiftTaskDate(date: Date) {
  if (isSameYear(date, new Date())) {
    return format(date, 'EEEE, LLL d');
  }

  return format(date, 'EEEE, LLL d, y');
}

type PartialTaskInstance = Pick<TaskInstance, 'dtstart' | 'dtend' | 'isOpenEnd' | 'assignee'>;
export function getInstanceShiftLabel(instance: PartialTaskInstance, usTimeFormat: boolean) {
  const timeLabel = getTimeLabel(instance, usTimeFormat);
  const assigneeLabel = instance.assignee ? instance.assignee.fullname : gettext('No assignee');

  return `${assigneeLabel}  • ${timeLabel}`;
}

function getTimeLabel(instance: PartialTaskInstance, usTimeFormat: boolean) {
  const { dtstart, dtend, isOpenEnd } = instance;

  const endDescription = isOpenEnd ? '' : ` - ${formatTime(dtend, usTimeFormat)}`;
  return `${formatTime(dtstart, usTimeFormat)}${endDescription}`;
}
